import React from 'react';
import { Spinner } from "react-activity";
import "react-activity/dist/library.css";

function ButtonNext({
  handleSubmit,
  buttonDisabled,
  isLoading,
  buttonText,
  error,
  errorMessage,
  className = ""        // ← ta in className!
}) {
  return (
    <div className='flex w-full flex-col items-center'>
      <div className='mb-2'>
        {error ? <p className='text-xs text-[#EF4444]'>{errorMessage}</p> : <p></p>}
      </div>   
      <button
        onClick={handleSubmit}
        disabled={buttonDisabled}
        className={
          // slå ihop dina default-klasser + den className som skickas in
          `flex items-center justify-center gap-2 
           py-5 px-5 w-full rounded-full text-base 
           text-white bg-[#9D4EDD] duration-200 
           hover:bg-[#6B21C8] disabled:bg-[#202020]
           ${className}`
        }
      >
        <div className='flex flex-1' />
        {isLoading && <Spinner color="#fff" size={10} speed={1} animating={true} />}
        {buttonText}
        <div className='flex flex-1' />
      </button>
    </div>    
  );
}

export default ButtonNext;
